// @todo refactor this when legacy wallet topups are no longer in use
export const BankName = "Barclays"
export const BankAccountNumber = "93310825"
export const BankSortCode = "20-36-08"

export const BankNameAUD = "ANZ"
export const BankAccountNumberAUD = "422 398 987"
export const BSBAUD = "013128"

export default {BankName, BankAccountNumber, BankSortCode, BankNameAUD, BankAccountNumberAUD, BSBAUD}
